import { render, staticRenderFns } from "./FirstSendGift.vue?vue&type=template&id=5f3ee0d2&scoped=true"
import script from "./FirstSendGift.vue?vue&type=script&lang=js"
export * from "./FirstSendGift.vue?vue&type=script&lang=js"
import style0 from "./FirstSendGift.vue?vue&type=style&index=0&id=5f3ee0d2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f3ee0d2",
  null
  
)

export default component.exports